import { gql } from '@apollo/client'

/**
 * PRO-133: gql-only LEAF for the metabase dashboard configs.
 *
 * The document lives here, NOT in `useMeDashboardConfigs.ts`, so the boot
 * path (`src/App/router.tsx`) can prefetch it without pulling `mapping.tsx`
 * (antd icons + @transifex) onto the entry graph - the same rule PRO-130
 * applied to `src/api/auth-queries`.
 *
 * Codegen's near-operation-file preset writes both this file's and the
 * hook's operation types into the SAME `./__generated__/types`, because
 * they sit in the same folder.
 *
 * `me { id }` is REQUIRED even though nothing reads it: without it Apollo
 * cannot normalize the user and writes this response inline at
 * `ROOT_QUERY.me`, which then collides with `GET_ME`'s `Reference` to
 * `UserType:<id>` on the same store field. Whichever of the two boot
 * requests lands second would win outright and erase the other's `me`.
 * With `id`, both documents merge onto the same entity.
 */
export const DASHBOARD_CONFIGS = gql`
  query DashboardConfigs {
    me {
      id
      dashboardConfigs {
        place
        url
      }
    }
  }
`
